export const DEFAULT_SHOP_CHANNEL_TYPE = 'OP20_01';

export const VISIT_CONSULT_TAB_REMODELING = 'RM_VISIT_RESERVED';

export const VISIT_CONSULT_TAB_INTERIOR = 'HF_VISIT_RESERVED';

export const VISIT_CONSULT_TAB = [
  {
    id: VISIT_CONSULT_TAB_REMODELING,
    label: '인테리어',
  },
  {
    id: VISIT_CONSULT_TAB_INTERIOR,
    label: '홈퍼니싱',
  },
];
